import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import iconPatternOne from '../../../images/icon-pattern-one.svg';
import iconPatternTwo from '../../../images/icon-pattern-two.svg';

const Perform2023RegistrationSection = ({ data }) => {
    return (
        <div className="cp-perform2023Register">
            <div className="cp-perform2023Register__inner" data-aos="fade-up">
                {data.perform23RegistrationSectionHeader &&
                    <h2>{data.perform23RegistrationSectionHeader}</h2>
                }
                {data.perform23RegistrationSectionTeaser &&
                    <div dangerouslySetInnerHTML={{ __html: data.perform23RegistrationSectionTeaser }} />
                }
                {data.perform23RegistrationSectionRepeaterSections &&
                    <div className="cp-perform2023Register__location l--flex">
                        {data.perform23RegistrationSectionRepeaterSections.map((registerSection, index) => (
                            <div className="cp-perform2023Register__location-section">
                                {registerSection.perform23RegistrationSectionLocationImage &&
                                    <GatsbyImage className="l--borderRadiusLarge" image={getImage(registerSection.perform23RegistrationSectionLocationImage.gatsbyImage)} alt={registerSection.perform23RegistrationSectionLocationImage.altText} />
                                }
                                {registerSection.perform23RegistrationSectionLocationName &&
                                    <h2>{registerSection.perform23RegistrationSectionLocationName}</h2>
                                }
                                {registerSection.perform23RegistrationSectionLocationHotel &&
                                    <span>{registerSection.perform23RegistrationSectionLocationHotel}</span>
                                }
                                {registerSection.perform23RegistrationSectionLocationRegistrationCheck === 'yes' ?
                                    <div className="l-buttonWrap"><a href={registerSection.perform23RegistrationSectionLocationRegistrationCta.url} target={registerSection.perform23RegistrationSectionLocationRegistrationCta.target} className="l-button">{registerSection.perform23RegistrationSectionLocationRegistrationCta.title}</a></div>
                                    :
                                    <button className="l-button l--disabled">Registration Closed</button>
                                }
                            </div>
                        ))}
                        <div className="l--absolute l-absoluteOne">
                            <img src={iconPatternOne} alt="" />
                        </div>
                        <div className="l--absolute l-absoluteTwo">
                            <img src={iconPatternTwo} alt="" />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
export default Perform2023RegistrationSection;

